import {
  ArrowTopRightIcon,
  ChatBubbleIcon,
  InstagramLogoIcon,
} from "@radix-ui/react-icons";
import { ApertureIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { Icons } from "../icons";
import { Button } from "../ui/button";
import LanguageSwitcher from "./language-switcher";

export default function SiteFooter() {
  const t = useTranslations("SiteFooter");

  return (
    <footer
      id="custom-footer"
      className="container flex flex-col max-w-5xl py-10 overflow-hidden transition-opacity opacity-60 hover:opacity-80"
    >
      <div className="flex flex-col items-center content-center sm:justify-between sm:flex-row ">
        <div className="flex flex-row items-center gap-3 md:gap-4 ">
          <Button variant={"link"} size={"sm"} asChild className="px-0">
            <Link href="/">
              <Icons.logo className="w-4 h-4 " />
            </Link>
          </Button>
          <Button variant={"link"} size={"sm"} className="px-0 text-xs" asChild>
            <Link href="/features">{t("features")}</Link>
          </Button>
          <Button variant={"link"} size={"sm"} className="px-0 text-xs" asChild>
            <Link href="/pricing">{t("pricing")}</Link>
          </Button>
          <Button variant={"link"} size={"sm"} className="px-0 text-xs" asChild>
            <Link href="https://about.tunis.events/" target="_blank">
              {t("about")}
            </Link>
          </Button>
          <Button
            variant={"link"}
            size={"sm"}
            className="px-0 text-xs "
            asChild
          >
            <Link
              href="https://tunis.events/terms-and-conditions"
              target="_blank"
            >
              {t("terms")}
            </Link>
          </Button>
        </div>
        <div className="flex flex-row items-center gap-4 ">
          <Button
            variant={"link"}
            size={"sm"}
            className="px-0 text-xs "
            asChild
          >
            <Link href="https://instagram.com/bip.events/" target="_blank">
              <InstagramLogoIcon className="w-4 h-4" />
            </Link>
          </Button>
          <Button
            variant={"link"}
            size={"sm"}
            className="px-0 text-xs "
            asChild
          >
            <Link href="https://darkroom.tunis.events/" target="_blank">
              <ApertureIcon className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          </Button>
          <Button
            variant={"link"}
            size={"sm"}
            className="px-0 text-xs "
            asChild
          >
            <Link
              href="https://wa.me/21658833013?text=Hello Bip, ..."
              target="_blank"
            >
              <ChatBubbleIcon className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          </Button>
          <LanguageSwitcher />
        </div>
      </div>
      <Link href="/create" className="transition-transform hover:scale-110">
        <div className="flex items-center justify-center gap-1 p-4 ">
          <div className="bg-gradient-to-r dark:from-[#0cabf7] from-[#9035cd] via-[#fd1d1d] dark:via-[#ffff00] to-[#e68600] dark:to-[#ff19c2]  !bg-clip-text text-transparent !bg-cover  transition-all text-xs font-semibold">
            {t("host-your-event-with-bip")}
          </div>
          <ArrowTopRightIcon className="w-3.5 h-3.5 text-[#fcb045]" />
        </div>
      </Link>
    </footer>
  );
}
